import { render } from "./Main.vue?vue&type=template&id=5f6cd34d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=5f6cd34d&scoped=true&lang=css"

import exportComponent from "D:\\Microsoft VS Code Project\\mft_stock_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6cd34d"]])

export default __exports__